






















































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import { AppMenus as _menu } from '@/shared/app.menu';
import LeftNavigationComponent from "../../Workspace/Components/LeftNavigation.vue";
// import ReportSummaryComponent from "./Reports/Summary.vue";
import TrackerFormComponent from "./TrackerForm.vue";
import StoryEditor from './StoryEditor.vue'
import { AppConstants as _app } from '@/shared/app.constants';
import { Tracker } from "@/entities";

const namespace: string = "tracker";

@Component ({
  components: {
      LeftNavigationComponent,
      TrackerFormComponent,
      StoryEditor
  }
})
export default class TrackerWorkspaceComponent extends Vue {

    @State(namespace) tracker!: Tracker;
    @Action("getTracker", { namespace }) getTracker: any;
    @Action("updateTracker", { namespace }) updateTracker: any;   

    showSideBar: boolean = true;
    isDirty: boolean = false;
    communicationId: number;

    downloadPdf() {   

    }    

    back() {
        this.$router.push({
            name: "Communication"
        });
    }    

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        if(this.isDirty) {
            this.updateTracker({
                "id": this.communicationId,
                "data": this.tracker.tracker
            })
            .then((resp) => {
                if(resp) {
                    this.isDirty = false;
                    this.tracker.selectedKey = key;
                    window.location.hash = `#${this.tracker.selectedKey}`;
                } else{
                    this.isDirty = false;
                    this.getTracker(this.communicationId); 
                }                
            })
        } else {
            this.tracker.selectedKey = key;
            window.location.hash = `#${this.tracker.selectedKey}`;
        }        
    }

    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    
    /** watch method to refresh page on page load */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
        if(changedRoute && changedRoute.name === 'communicationTrackerForm') {

            const commId = changedRoute.params.communicationId;
            this.communicationId = commId;

            if(this.$route.hash)
                this.tracker.selectedKey = this.$route.hash.substr(1);
            else
                window.location.hash = `#${this.tracker.selectedKey}`;

            // Added this condition to hadle the route change on hash value update
            if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.communicationId !== previousRoute.params.communicationId ) {
                this.getTracker(commId);                
            }
        }
    }
    
}
